import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { LIST_BILLING_ENTITY_BANK_ACCOUNTS_RESOURCE } from 'src/features/billingEntityBankAccounts/api/useListBillingEntityBankAccounts';
import { bankAccountMessages } from 'src/features/billingEntityBankAccounts/utils/messages';
import { useCreateBillingEntityBankAccount } from 'src/features/billingEntityBankAccounts/api/useCreateBillingEntityBankAccount';
import BillingEntityBankAccountFormModal from 'src/features/billingEntityBankAccounts/components/forms/BillingEntityBankAccountFormModal';

interface CreateBillingEntityBankAccountFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateBillingEntityBankAccountFormModal<TData>({
    className,
    semantics,
}: CreateBillingEntityBankAccountFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateBillingEntityBankAccount({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_BILLING_ENTITY_BANK_ACCOUNTS_RESOURCE] });
            toast({
                title: formatMessage(bankAccountMessages.createBankAccountSuccess),
                description: formatMessage(bankAccountMessages.createBankAccountSuccessDescription),
            });
        },
    });

    return (
        <BillingEntityBankAccountFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(bankAccountMessages.addBankAccountSubtitle)}
        />
    );
}

export default CreateBillingEntityBankAccountFormModal;
